import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import Raven from 'raven-js';
import { Spacer } from 'foundations-components/components/Spacer';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const computeModalContent = ({
  forecastSubmission,
  forecastSubmissionTimestamp,
  isMostRecentSubmissionInPeriod,
  isPeriodCompleteForAccuracy,
  isSubmissionForUser,
  isSubmissionOnlyRemaining,
  userSubmissionAmount
}) => {
  if (forecastSubmission.value === null || forecastSubmission.currencyCode === '') {
    Raven.captureMessage('Forecast submission is missing value or currency code', {
      extra: {
        currencyCode: forecastSubmission.currencyCode,
        value: forecastSubmission.value
      }
    });
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "deleteSubmissionModal.body.noCurrencyCodeOrValueError"
    });
  }
  const amount = I18n.formatIntlCurrency(forecastSubmission.value, {
    currencyCode: forecastSubmission.currencyCode
  });
  const userSubmissionAmountFormatted = I18n.formatIntlCurrency(userSubmissionAmount, {
    currencyCode: forecastSubmission.currencyCode
  });
  const date = I18n.moment(forecastSubmissionTimestamp).format('MMMM Do, YYYY');
  const computeHistoricalPeriodContentForTeam = () => {
    if (isSubmissionOnlyRemaining) {
      // Case: deleting only submission with at least one rep submission on the team for the same period
      if (userSubmissionAmount !== 0) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "deleteSubmissionModal.body.confirmAmountAndDate",
            options: {
              amount,
              date
            }
          }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsxs(Text, {
            as: "span",
            children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "deleteSubmissionModal.body.userSubmissionRollupWarning",
              options: {
                amount: userSubmissionAmountFormatted
              }
            }), /*#__PURE__*/_jsx(Spacer, {
              display: "inline-block",
              space: "100"
            }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "deleteSubmissionModal.body.unableToAddTeamSubmissionWarning"
            })]
          })]
        });
      }

      // Case: deleting only submission without any rep submissions on the team for the same period
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "deleteSubmissionModal.body.deletionWarning",
          options: {
            amount,
            date
          }
        }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsxs(Text, {
          as: "span",
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "deleteSubmissionModal.body.unableToAddTeamSubmissionWarning"
          }), /*#__PURE__*/_jsx(Spacer, {
            display: "inline-block",
            space: "100"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "deleteSubmissionModal.body.deleteOnlySubmission"
          })]
        })]
      });
    }
    if (isMostRecentSubmissionInPeriod) {
      // Case: deleting most recent submission with at least one other team submission existing for the same period
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "deleteSubmissionModal.body.confirmAmountAndDate",
          options: {
            amount,
            date
          }
        }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsxs(Text, {
          as: "span",
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "deleteSubmissionModal.body.unableToAddTeamSubmissionWarning"
          }), /*#__PURE__*/_jsx(Spacer, {
            display: "inline-block",
            space: "100"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "deleteSubmissionModal.body.deleteMostRecentTeamSubmission"
          })]
        })]
      });
    }

    // Case: deleting submission other than the most recent, with at least one other team submission existing for the same period
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "deleteSubmissionModal.body.confirmAmountAndDate",
        options: {
          amount,
          date
        }
      }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "deleteSubmissionModal.body.unableToAddTeamSubmissionWarning"
      })]
    });
  };
  const computeIncompletePeriodContentForTeam = () => {
    if (isSubmissionOnlyRemaining) {
      // Case: deleting only submission with at least one rep submission on the team for the same period
      if (userSubmissionAmount !== 0) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "deleteSubmissionModal.body.confirmAmountAndDate",
            options: {
              amount,
              date
            }
          }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "deleteSubmissionModal.body.rollupWillDisplayWarning",
            options: {
              amount: userSubmissionAmountFormatted
            }
          })]
        });
      }

      // Case: deleting only submission without any rep submissions on the team for the same period
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "deleteSubmissionModal.body.confirmAmountAndDate",
          options: {
            amount,
            date
          }
        }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsxs(Text, {
          as: "span",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "deleteSubmissionModal.body.deleteOnlySubmission"
          }), /*#__PURE__*/_jsx(Spacer, {
            display: "inline-block",
            space: "100"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "deleteSubmissionModal.body.submissionCanBeUpdatedNotice"
          })]
        })]
      });
    }
    if (isMostRecentSubmissionInPeriod) {
      // Case: deleting most recent submission with at least one other team submission existing for the same period
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "deleteSubmissionModal.body.confirmAmountAndDate",
          options: {
            amount,
            date
          }
        }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "deleteSubmissionModal.body.deleteMostRecentTeamSubmission"
        })]
      });
    }

    // Case: deleting submission other than the most recent, with at least one other team submission existing for the same period
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "deleteSubmissionModal.body.confirmAmountAndDate",
      options: {
        amount,
        date
      }
    });
  };
  const computeHistoricalPeriodContentForUser = () => {
    // Case: deleting the only submission
    if (isSubmissionOnlyRemaining) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "deleteSubmissionModal.body.deletionWarning",
          options: {
            amount,
            date
          }
        }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsxs(Text, {
          as: "span",
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "deleteSubmissionModal.body.unableToAddWarning"
          }), /*#__PURE__*/_jsx(Spacer, {
            display: "inline-block",
            space: "100"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "deleteSubmissionModal.body.deleteOnlySubmission"
          })]
        })]
      });
    }

    // Case: deleting most recent submission with other submissions present
    if (isMostRecentSubmissionInPeriod) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "deleteSubmissionModal.body.confirmAmountAndDate",
          options: {
            amount,
            date
          }
        }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsxs(Text, {
          as: "span",
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "deleteSubmissionModal.body.unableToAddWarning"
          }), /*#__PURE__*/_jsx(Spacer, {
            display: "inline-block",
            space: "100"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "deleteSubmissionModal.body.deleteMostRecentSubmission"
          })]
        })]
      });
    }

    // Case: deleting submission other than the most recent
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "deleteSubmissionModal.body.confirmAmountAndDate",
        options: {
          amount,
          date
        }
      }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsxs(Text, {
        as: "span",
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "deleteSubmissionModal.body.unableToAddWarning"
        }), /*#__PURE__*/_jsx(Spacer, {
          display: "inline-block",
          space: "100"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "deleteSubmissionModal.body.deletePriorSubmission"
        })]
      })]
    });
  };
  const computeIncompletePeriodContentForUser = () => {
    // Case: deleting most recent submission, no other submissions present
    if (isSubmissionOnlyRemaining) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "deleteSubmissionModal.body.confirmAmountAndDate",
          options: {
            amount,
            date
          }
        }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsxs(Text, {
          as: "span",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "deleteSubmissionModal.body.deleteOnlySubmission"
          }), /*#__PURE__*/_jsx(Spacer, {
            display: "inline-block",
            space: "100"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "deleteSubmissionModal.body.submissionCanBeUpdatedNotice"
          })]
        })]
      });
    }

    // Case: deleting most recent submission, other submissions present
    if (isMostRecentSubmissionInPeriod) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "deleteSubmissionModal.body.confirmAmountAndDate",
          options: {
            amount,
            date
          }
        }), /*#__PURE__*/_jsx(Spacer, {
          display: "inline-block",
          space: "100"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "deleteSubmissionModal.body.deleteMostRecentSubmission"
        })]
      });
    }

    // Case: deleting submission other than the most recent
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "deleteSubmissionModal.body.confirmAmountAndDate",
      options: {
        amount,
        date
      }
    });
  };
  const computeContentForTeam = () => {
    if (!isPeriodCompleteForAccuracy) {
      return computeIncompletePeriodContentForTeam();
    }
    return computeHistoricalPeriodContentForTeam();
  };
  const computeContentForUser = () => {
    if (!isPeriodCompleteForAccuracy) {
      return computeIncompletePeriodContentForUser();
    }
    return computeHistoricalPeriodContentForUser();
  };
  if (!isSubmissionForUser) {
    return computeContentForTeam();
  }
  return computeContentForUser();
};